<template>
  <v-snackbar :top="true" v-model="showSnackbar" color="warning" rounded="pill">
    {{ snackbarContent }}
  </v-snackbar>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  methods: {
    ...mapActions({
      closeSnackbar: "Snackbar/setSnackbar",
    }),
  },
  computed: {
    showSnackbar: {
      get() {
        return this.$store.state.Snackbar.showSnackbar;
      },
      set(value) {
        this.$store.commit("Snackbar/SET_SNACKBAR", value);
      },
    },

    ...mapState({
      //showSnackbar: (state) => state.Snackbar.showSnackbar,
      snackbarContent: (state) => state.Snackbar.snackbarContent,
    }),
  },
};
</script>

<style lang="scss" scoped></style>
